import { gql } from '@apollo/client';

export const GET_COMPANY_MEMBERS = gql`
  query CompanyMembers($companyId: ID!, $hidden: Boolean) {
    companyMembers(companyId: $companyId, hidden: $hidden) {
      id
      user{
        id
        email
        profile {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
